import script from "./AddressSearchModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressSearchModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddressSearchModal.vue?vue&type=style&index=0&id=1a225e09&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a225e09"]])

export default __exports__